<div class="list-source-item__container">
  <button mat-list-item class="list-source-item__source" [class.active]="active" (click)="activate.emit(source.id)">{{ source.id }}.{{ source.title }}</button>
</div>
